
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.606 17.58l-.108-.223c-.303-.734-4.03-1.846-4.334-1.868l-.238.022c-.455.09-.953.512-1.928 1.38a.577.577 0 01-.694.088c-1.278-.734-2.838-2.202-3.618-3.091-.846-.957-1.864-2.536-2.34-3.803-.087-.245 0-.512.173-.69C8.624 8.372 9.1 7.883 9.144 7.35c.022-.311-.629-4.248-1.3-4.626l-.195-.134c-.434-.289-1.084-.711-1.799-.556a1.957 1.957 0 00-.498.2c-.477.312-1.669 1.157-2.21 2.247-.325.69-.477 6.939 4.073 12.21 4.507 5.227 10.076 5.449 10.9 5.271h.021l.065-.022c1.127-.423 2.08-1.513 2.449-1.98.671-.823.216-1.823-.044-2.38z"}})])
          )
        }
      }
    